import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.green2};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.large};
  }
`

export const Content = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 8px;

  color: ${theme.colors.gray900};
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.normal};
    gap: 16px;
  }
`
